"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyRoiPreset = exports.trackEditOption = exports.addBackgroundImage = exports.pickBackgroundImage = exports.addROICalculatorVariableInput = exports.updateRoiCalculatorRichText = exports.updateVariableInputs = exports.updateROICalculatorWidget = void 0;
var lodash_1 = require("lodash");
var ROIVariableKeyUtils_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROIVariableKey/ROIVariableKeyUtils");
var slate_1 = require("slate");
var WidgetActions_1 = require("../WidgetActions");
var ShowImagePicker_1 = __importDefault(require("Project/QwilrEditor/ShowImagePicker"));
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var ROICalculatorWidget_1 = require("Project/QwilrEditor/Widgets/ROICalculatorWidget/ROICalculatorWidget");
var ROIPresetsData_1 = require("Project/QwilrEditor/Widgets/ROICalculatorWidget/ROIPresetsData");
function assertROICalculator(node) {
    if (!slate_1.Element.isElement(node)) {
        throw new Error("Node is not an Element");
    }
    if (node.type !== "roiCalculator") {
        throw new Error("Element is not an ROICalculator");
    }
}
var updateROICalculatorWidget = function (editor, path, updatedData) {
    var blockEntry = slate_1.Editor.node(editor, path);
    assertROICalculator(blockEntry[0]);
    var existingData = blockEntry[0].data;
    var data = __assign(__assign({}, existingData), updatedData);
    slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
};
exports.updateROICalculatorWidget = updateROICalculatorWidget;
var updateVariableInputs = function (editor, path, updatedInputs) {
    var blockEntry = slate_1.Editor.node(editor, path);
    assertROICalculator(blockEntry[0]);
    var existingData = blockEntry[0].data;
    var inputs = __assign(__assign({}, existingData.inputs), updatedInputs);
    updateROICalculatorWidget(editor, path, { inputs: inputs });
};
exports.updateVariableInputs = updateVariableInputs;
var updateRoiCalculatorRichText = function (editor, path, richTextKey, value) {
    var blockEntry = slate_1.Editor.node(editor, path);
    assertROICalculator(blockEntry[0]);
    var existingData = blockEntry[0].data;
    var newData = (0, lodash_1.cloneDeep)(existingData);
    (0, lodash_1.set)(newData, "".concat(richTextKey, ".plain"), value);
    slate_1.Transforms.setNodes(editor, { data: newData }, { at: path });
};
exports.updateRoiCalculatorRichText = updateRoiCalculatorRichText;
var applyRoiPreset = function (editor, path, presetId) {
    var data = __assign({}, (0, ROIPresetsData_1.getROIPresetDataFromId)(presetId));
    slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
};
exports.applyRoiPreset = applyRoiPreset;
var addROICalculatorVariableInput = function (editor, path) {
    var blockEntry = slate_1.Editor.node(editor, path);
    assertROICalculator(blockEntry[0]);
    var existingData = blockEntry[0].data;
    var newData = (0, lodash_1.cloneDeep)(existingData);
    newData.variableCounter++;
    var nextKey = (0, ROIVariableKeyUtils_1.getKeyFromNumber)(newData.variableCounter);
    newData.inputs[nextKey] = {
        label: "New input",
        min: 0,
        max: 100,
        prefix: "$",
        suffix: "",
        value: 10,
    };
    slate_1.Transforms.setNodes(editor, { data: newData }, { at: path });
};
exports.addROICalculatorVariableInput = addROICalculatorVariableInput;
var pickBackgroundImage = function (di, editor, path, router) { return __awaiter(void 0, void 0, Promise, function () {
    var pickerResult, url, type, uploadId, altDescription, imageData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, di.invoke(ShowImagePicker_1.default)()];
            case 1:
                pickerResult = _a.sent();
                url = pickerResult.url, type = pickerResult.type, uploadId = pickerResult.uploadId, altDescription = pickerResult.altDescription;
                imageData = {};
                (0, WidgetActions_1.handleFastUploadResult)(type, imageData, uploadId, url, altDescription);
                router.onEvent(new WidgetManager_1.WidgetEvent("roiCalculator", {
                    action: "addImage",
                    image: imageData,
                    path: path,
                }), editor);
                return [2];
        }
    });
}); };
exports.pickBackgroundImage = pickBackgroundImage;
var addBackgroundImage = function (editor, path, image, telemetry) {
    if (image.src) {
        updateROICalculatorWidget(editor, path, { backgroundImageUrl: image.src });
        telemetry.roiCalculatorBackgroundImageAdded();
    }
    else {
        updateROICalculatorWidget(editor, path, { backgroundImageUploadId: image.uploadId });
    }
};
exports.addBackgroundImage = addBackgroundImage;
var trackEditOption = function (telemetry, element, key, value) {
    switch (element) {
        case ROICalculatorWidget_1.ROIElement.Slider: {
            telemetry.roiCalculatorEditSliderOption(key, value);
            break;
        }
        case ROICalculatorWidget_1.ROIElement.Result: {
            telemetry.roiCalculatorEditROIOption(key, value);
            break;
        }
        case ROICalculatorWidget_1.ROIElement.VariableInput: {
            telemetry.roiCalculatorEditVariableInput(key, value);
            break;
        }
    }
};
exports.trackEditOption = trackEditOption;
